module.exports = __webpack_public_path__ + "img/dingle-main.63f53e7d.webp";